import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../../api/axiosInstance";
import Header from "../PublicHeader";
import Footer from "../Footer";

export default function ResetPassword() {
    const location = useLocation();
    const token = new URLSearchParams(location.search).get("token");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setMessage("");

        try {
            const res = await axios.post<{ message: string }>("/api/reset-password", { token, password });
            setMessage(res.data.message);
            setTimeout(() => navigate("/login"), 3000);
        } catch (err: any) {
            setError(err.response?.data?.error || "Failed to reset password.");
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex flex-col">
            <Header />
            <main className="flex-grow flex items-center justify-center px-4 py-12">
                <div className="w-full max-w-lg bg-white shadow-xl rounded-xl p-8 sm:p-10">
                    <h2 className="text-2xl sm:text-3xl font-extrabold text-blue-700 text-center mb-6">
                        🔐 Reset Your Password
                    </h2>

                    {message && (
                        <div className="bg-green-50 text-green-700 px-4 py-2 rounded text-center mb-4">
                            {message}
                        </div>
                    )}
                    {error && (
                        <div className="bg-red-50 text-red-700 px-4 py-2 rounded text-center mb-4">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                            <input
                                type="password"
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Enter new password"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition duration-300"
                        >
                            🔁 Reset Password
                        </button>
                    </form>

                    <p className="text-center text-sm text-gray-500 mt-6">
                        Remembered your password?{" "}
                        <a href="/login" className="text-blue-600 hover:underline font-medium">
                            Go to Login
                        </a>
                    </p>
                </div>
            </main>
            <Footer />
        </div>
    );
}
